function getElementIdValidator() {

    function checkElementId(isRequired, props, propName, componentName) {
        const propValue = props[propName];
        
        if (propValue == null) {
            if (isRequired) {
                if (propValue === null) {
                    return new Error('The prop `' + propName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                }
                return new Error('The prop `' + propName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }

            return null;
        }

        const propType = typeof propValue;

        if (propType !== 'string') {
            return new Error('Invalid prop `' + propName + '` of type `' + propType + '` supplied to `' + componentName + '`, expected `string`.');
        }

        if (!/^[a-z]+[a-z0-9\-_\:\.]*$/i.test(propValue)) {
            return new Error('Invalid prop `' + propName + '` value `' + propValue + '` supplied to `' + componentName + '`, expected valid element id.');
        }

        return null;
    }

    const chainedCheckType = checkElementId.bind(null, false);
    chainedCheckType.isRequired = checkElementId.bind(null, true);
    chainedCheckType.fnNormalizeId = id => (id + '').replace(/^[^a-z]/i, 'a$&').replace(/[^a-z0-9\-_\:\.]/gi, '_');

    return chainedCheckType;
}

function getIntegerValidator() {
    function checkInteger(isRequired, isStringAllowed, range, props, propName, componentName) {
        const propValue = props[propName];
        
        if (propValue == null) {
            if (isRequired) {
                if (propValue === null) {
                    return new Error('The prop `' + propName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                }
                return new Error('The prop `' + propName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }

            return null;
        }

        const propType = typeof propValue;

        if ((propType === 'number') || (propType === 'string') && isStringAllowed) {
            if (isNaN(propValue) || (Number.parseFloat(propValue) != Number.parseInt(propValue))) {
                return new Error('Invalid prop `' + propName + '` value `' + propValue + '` supplied to `' + componentName + '`, expected valid integer.');
            }
        }
        else {
            if (isStringAllowed) {
                return new Error('Invalid prop `' + propName + '` of type `' + propType + '` supplied to `' + componentName + '`, expected `number` or `string`.');
            }
            return new Error('Invalid prop `' + propName + '` of type `' + propType + '` supplied to `' + componentName + '`, expected `number`.');
        }

        if (Boolean(range)) {
            if (!Array.isArray(range) || (range.length > 2)) {
                return new Error('Invalid range of property `' + propName + '` values supplied to `' + componentName + '`, expected an array with length 2 or less.');
            }

            let minValue = null;
            let maxValue = null;
            if ((range.length > 0) && (range[0] != null)) {
                minValue = range[0] * 1;

                if (isNaN(minValue)) {
                    return new Error('Invalid range min value `' + range[0] + '` for `' + propName + '` property of `' + componentName + '`, expected valid numeric.');
                }
            }

            if ((range.length > 1) && (range[1] != null)) {
                maxValue = range[1] * 1;

                if (isNaN(maxValue)) {
                    return new Error('Invalid range max value `' + range[1] + '` for `' + propName + '` property of `' + componentName + '`, expected valid numeric.');
                }
            }

            const intValue = propValue * 1;

            if ((minValue != null) && (intValue < minValue)) {
                return new Error('Invalid prop `' + propName + '` value `' + intValue + '` supplied to `' + componentName + '`, expected valid integer greater than or equal to `' + minValue + '`.');
            }
            if ((maxValue != null) && (intValue > maxValue)) {
                return new Error('Invalid prop `' + propName + '` value `' + intValue + '` supplied to `' + componentName + '`, expected valid integer less than or equal to `' + maxValue + '`.');
            }
        }

        return null;
    }

    function makeInRange (isRequired, isStringAllowed) {
        return range => {
            const r = checkInteger.bind(null, Boolean(isRequired), Boolean(isStringAllowed), range);
            if (isRequired == null) {
                r.isRequired = checkInteger.bind(null, true, Boolean(isStringAllowed), range);
            }
            if (isStringAllowed == null) {
                r.isStringAllowed = checkInteger.bind(null, Boolean(isRequired), true, range);
            }
            if ((isRequired == null) && (isStringAllowed == null)) {
                r.isRequired.isStringAllowed = r.isStringAllowed.isRequired = checkInteger.bind(null, true, true, range);
            }
            return r;
        }
    }

    const chainedCheckType = checkInteger.bind(null, false, false, []);

    chainedCheckType.isRequired = checkInteger.bind(null, true, false, []);
    chainedCheckType.isRequired.isStringAllowed = checkInteger.bind(null, true, true, []);
    chainedCheckType.isRequired.inRange = makeInRange(true, null);
    chainedCheckType.isRequired.isStringAllowed.inRange = makeInRange(true, true);

    chainedCheckType.isStringAllowed = checkInteger.bind(null, false, true, []);
    chainedCheckType.isStringAllowed.isRequired = checkInteger.bind(null, true, true, []);;
    chainedCheckType.isStringAllowed.inRange = makeInRange(null, true);
    chainedCheckType.isStringAllowed.isRequired.inRange = makeInRange(true, true);

    chainedCheckType.inRange = makeInRange(null, null);

    return chainedCheckType;
}

export const PropTypesEx = {
    elementId: getElementIdValidator(),
    integer: getIntegerValidator(),
}
